import { DiscoverList } from '../components';
import { DiscoverListTabEnum } from '../components/discover-list';

const DiscoverTeam = () => {
  return <DiscoverList tab={DiscoverListTabEnum.Team} />;
};

export default DiscoverTeam;
